module.exports = __webpack_public_path__ + "media/images/common/cancel_btn_ov-e35f045492a68f5db1abd83f38de7e42.png";